
import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
} from "react-share";
import Icon from '@mdi/react';
import { useStaticQuery, graphql } from "gatsby"
import { mdiTwitter, mdiFacebook, mdiLinkedin, mdiEmail, mdiLinkBoxVariant } from '@mdi/js';

const SocialShare = (props) => {
  const [isOpen, setIsOpen] = useState(false)

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            url
          }
        }
      }
    `
  )

  const url = site.siteMetadata.url + '#' + props.sectionId

  function handleClick() {
    if (!isOpen) {
      setIsOpen(true)
    } else {
      setIsOpen(false)
    }
  }

  return (
    <div className="social-share">
      <button className="button is-small is-family-sans-serif is-uppercase social-share-button" onClick={handleClick}>
        <span>Share</span>
      </button>

      {isOpen &&

        <div className="social-share-roll">
          <EmailShareButton
            url={url}
            className="mx-1 animate-button"
            subject={site.siteMetadata.title + ' for "' + props.sectionTitle +'"'}
          >
            <Icon path={mdiEmail} size={1.2} title="Share result as email" />
          </EmailShareButton>

          <a href={`#${props.sectionId}`} className="has-text-grey-dark mx-1 animate-button">
            <Icon path={mdiLinkBoxVariant} size={1.2} title="Link to section" />
          </a>

          <FacebookShareButton
            className="mx-1 animate-button"
            url={url}
            quote={site.siteMetadata.title + ' for "' + props.sectionTitle +'"'}
            hashtag='#RailsSurvey2020'
          >
            <Icon path={mdiFacebook} size={1.2} title="Share result on Facebook" />
          </FacebookShareButton>

          <LinkedinShareButton
            url={url}
            className="mx-1 animate-button"
            source={site.siteMetadata.title}
            title={props.sectionTitle}
            summary={site.siteMetadata.description}
          >
            <Icon path={mdiLinkedin} size={1.2} title="Share on LinkedIn" />
          </LinkedinShareButton>

          <TwitterShareButton
            className="mx-1 animate-button"
            url={url}
            title={site.siteMetadata.title + ' for "' + props.sectionTitle +'"'}
            via={site.siteMetadata.author}
            hashtags={['RailsSurvey2020']}
          >
            <Icon path={mdiTwitter} size={1.2} title="Share on Twitter" />
          </TwitterShareButton>
        </div>
      }
    </div>
  )
}

SocialShare.propTypes = {
  sectionId: PropTypes.string,
  sectionTitle: PropTypes.string,
}

SocialShare.defaultProps = {
  sectionId: "",
  sectionTitle: "",
}

export default SocialShare